import { render, staticRenderFns } from "./DialogMoveTo.vue?vue&type=template&id=480400f8&"
import script from "./DialogMoveTo.vue?vue&type=script&lang=js&"
export * from "./DialogMoveTo.vue?vue&type=script&lang=js&"
import style0 from "./DialogMoveTo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports